import { render, staticRenderFns } from "./TerritoryMap.vue?vue&type=template&id=2bbbd4ca"
import script from "./TerritoryMap.vue?vue&type=script&lang=js"
export * from "./TerritoryMap.vue?vue&type=script&lang=js"
import style0 from "./TerritoryMap.vue?vue&type=style&index=0&id=2bbbd4ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports